'use client';
import styled from 'styled-components';

export const StyledRecommendedContainer = styled.div`
  max-width: 100vw;
`;

export const ArrowContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
  button {
    border: none;
  }
`;

export const RecommendedPlanContainer = styled.div`
  width: 90%;
  background: ${props => props.theme.colors.background.lightest};
  display: flex;
  flex-direction: column;
  border-radius: 32px;
  text-align: center;
  align-items: center;
  padding: ${props => props.theme.spacing(8, 6)};
  margin: auto;
  margin-bottom: ${props => props.theme.spacing(22)};
  @media ${({ theme }) => theme.tablet} {
    padding: 5%;
    margin: auto;
    width: 80%;
    display: flex;
    flex-direction: row-reverse;
    text-align: left;
  }
  max-width: 1020px;
`;

export const PlanInformation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  button {
    padding-top: ${props => props.theme.spacing(4)};
    text-align: center;
  }
  gap: ${props => props.theme.spacing(1)};
  @media ${({ theme }) => theme.tablet} {
    width: 50%;
    button {
      text-align: left;
    }
  }
`;

export const MobileHeader = styled.div`
  display: block;
  @media ${({ theme }) => theme.tablet} {
    display: none;
  }
`;

export const DesktopHeader = styled.div`
  display: none;
  @media ${({ theme }) => theme.tablet} {
    display: block;
  }
`;

export const SummaryHeadline = styled.h3`
  ${({ theme }) => theme.typography.heading3}
  padding-bottom:${props => props.theme.spacing(2)}
`;

export const PupSummary = styled.div`
  width: 100%;
  color: ${props => props.theme.colors.text.primary};
  border-radius: 32px;
  text-align: left;
  margin: auto;
  @media ${props => props.theme.laptop} {
    display: flex;
    gap: ${props => props.theme.spacing(8)};
  }
`;

export const HighlightText = styled.span`
  font-weight: bold;
  background: rgba(112, 176, 199, 0.28);
  padding: 1px;
  border-radius: 5px;
  text-transform: capitalize;
`;

export const ImageContainer = styled.div`
  width: 50%;
`;

export const StarRating = styled.div`
  margin-bottom: ${props => props.theme.spacing(2)};
  &::before {
    font-size: 1rem;
    letter-spacing: 2px;
    content: '★★★★★';
    background-color: ${props => props.theme.colors.secondary.egg};
    background-clip: text;
    /* stylelint-disable-next-line */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const DesktopButtonContainer = styled.div`
  display: none;
  @media ${({ theme }) => theme.tablet} {
    display: block;
    margin: ${props => props.theme.spacing(4, 0, 5)};
  }
`;

export const MobileButtonContainer = styled.div`
  display: block;
  @media ${({ theme }) => theme.tablet} {
    display: none;
  }
`;

export const RecipesText = styled.p`
  ${({ theme }) => theme.typography.heading5}
  color: ${props => props.theme.colors.text.secondary};
`;

export const Price = styled.div`
  font-weight: bold;

  .full-price {
    color: ${({ theme }) => theme.colors.text.tertiary};
    margin: 0 ${({ theme }) => theme.spacing(2)};
  }

  .percentage-off {
    font-weight: normal;
  }

  padding: ${props => props.theme.spacing(1, 0)};
`;

export const DisplayedPrice = styled.span`
  ${({ theme }) => theme.typography.body}
  margin-right: ${({ theme }) => theme.spacing(1)};
  font-weight: bold;
`;

export const SavePercentage = styled.span`
  ${({ theme }) => theme.typography.body}
  color: ${({ theme }) => theme.colors.status.successPrimary};
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const StrikeThroughPrice = styled.span`
  ${({ theme }) => theme.typography.body}
  color:#CAB5AA;
  margin-right: ${({ theme }) => theme.spacing(1)};
  text-decoration-line: line-through;
  text-transform: capitalize;
`;
